<template>
<div id="Login">
    <div class="login-head">
        <div class="left">
            <!-- <span class="platform-name" v-if="operatorCustom.admin_name">{{operatorCustom.admin_name}}</span> -->
            <!-- <img class="platform-img" v-else :src="operatorCustom.login_logo" /> -->
            <!-- <div class="line"></div> -->
            <div class="text" v-if='loginType === LOGIN_TYPE_S[0]'>平台管理后台</div>
            <div class="text" v-if='loginType === LOGIN_TYPE_S[1]'>运营商管理后台</div>
            <div class="text" v-if='loginType === LOGIN_TYPE_S[2]'>分账账户管理后台</div>
        </div>
        <div class="right">
            <a-dropdown :trigger="['click']" overlay-class-name='login-type-change-dropdown' placement='bottomCenter'>
                <div class="change-item" @click="e => e.preventDefault()" >
                    <i class="icon i-switch" />
                    <template v-if="loginType === LOGIN_TYPE_S[0]">平台管理后台</template>
                    <template v-if="loginType === LOGIN_TYPE_S[1]">运营商管理后台</template>
                    <template v-if="loginType === LOGIN_TYPE_S[2]">分账账户管理后台</template>
                </div>
                <a-menu slot="overlay">
                    <a-menu-item @click="handleTypeChange(LOGIN_TYPE_S[1])" key="oper">
                        <img src="../assets/images/login-operator.png" alt="运营商"/> 运营商管理后台
                    </a-menu-item>
                    <a-menu-item @click="handleTypeChange(LOGIN_TYPE_S[2])" key="settle">
                        <img src="../assets/images/login-clearing_account.png" alt="分账账户"/> 分账账户管理后台
                    </a-menu-item>
                    <a-menu-item @click="handleTypeChange(LOGIN_TYPE_S[0])" key="admin">
                        <img src="../assets/images/login-admin.png" alt="平台"/> 平台管理后台
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
        </div>
    </div>
    <div class="login-container">
        <div class="login-form" :class="findBack && 'find-back-form'">
            <div class="logo">
                <img v-if="loginType === LOGIN_TYPE_S[0]" src="../assets/images/login-admin.png" />
                <img v-if="loginType === LOGIN_TYPE_S[1]" src="../assets/images/login-operator.png" />
                <img v-if="loginType === LOGIN_TYPE_S[2]" src="../assets/images/login-clearing_account.png" />
            </div>
            <div class="login-type" v-if='loginType === LOGIN_TYPE_S[0]'>管理员登录</div>
            <div class="login-type" v-if='loginType === LOGIN_TYPE_S[1]'>{{findBack ? '运营商密码找回' : '运营商登录'}}</div>
            <div class="login-type" v-if='loginType === LOGIN_TYPE_S[2]'>分账账户登录</div>

            <div class="form-content" v-if="!findBack">
                <a-input class="login-form-item" placeholder='请输入用户名' v-model="loginForm.username" @keydown.enter="handleFocusPwd">
                    <i class="icon i-user_management" slot="prefix"/>
                </a-input>
                <a-input class="login-form-item" placeholder='请输入密码' v-model="loginForm.password" @keydown.enter="handleLogin" type="password" ref="password-input">
                    <i class="icon i-password" slot="prefix"/>
                </a-input>
                <a-button class="login-form-button" type="primary" @click="handleLogin">登 录</a-button>
            </div>

            <PasswordFindBack v-else @success="findBack = false"/>

            <a-button class="find-back-tip" type="link" v-if='loginType === LOGIN_TYPE_S[1]' @click="findBack = !findBack">{{findBack ? '返回登录' : '忘记密码？'}}</a-button>
        </div>
    </div>
    <!-- <div class="login-foot" style="visibility:hidden;">Copyright © 2020 Powerliber 杭州柏来科技有限公司</div> -->
</div>
</template>

<script>
import Core from '../core';
const LOGIN_TYPE = Core.Const.LOGIN_TYPE
const OPERATOR_MODE = Core.Const.OPERATOR.MODE

const APP_NAME = process.env['VUE_APP_APP_NAME']
const isTest = !window.location.href.includes('powerliber')

export default {
    components: {
        PasswordFindBack: () => import('../components/panel/PasswordFindBack')
    },
    data() {
        return {
            LOGIN_TYPE_S: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR, LOGIN_TYPE.CLEARING_ACCOUNT],
            loginType: '',

            typeSelectVisible: false,

            loginForm: {
                username: '',
                password: '',
            },
            user: {},

            findBack: false,
        };
    },
    computed: {
        operatorCustom() {
            let operatorCustom = Core.Data.getOperatorCustom() || {}
            switch (APP_NAME) {
                case 'QIANNIU':
                    return {
                        admin_name: operatorCustom.admin_name || '千 牛 充 电',
                        login_logo: '',
                    }
                case 'AIMA':
                    return {
                        admin_name: operatorCustom.admin_name || '',
                        login_logo: require('@/assets/images/logo-aima.png'),
                    }
                default:
                    return {
                        admin_name: operatorCustom.admin_name || '',
                        login_logo: require('@/assets/images/logo-powerliber.png'),
                    }
            }
        },
    },
    created() {
        Core.Data.setServiceChargeTipFlag(0)

        let token = this.$route.query.token
        if (token) {
            this.handleLoginByToken(token)
        }

        if (Core.Data.getLoginType()) {
            this.loginType = Core.Data.getLoginType();
        } else {
            this.loginType = LOGIN_TYPE.OPERATOR;
            Core.Data.setLoginType(LOGIN_TYPE.OPERATOR);
        }
    },
    mounted() {
    },
    beforeDestroy() {
		clearInterval(this.timer)
	},
    methods: {
        handleTypeChange(loginType) {
            this.loginType = loginType;
            this.findBack = false
            Core.Data.setLoginType(this.loginType)
        },
        handleFocusPwd() {
            this.$refs['password-input'].focus()
        },
        async handleLogin() {
            const form = Core.Util.deepCopy(this.loginForm)
            if (!form.username) {
                return this.$message.warning('请输入用户名')
            }
            if (!form.password) {
                return this.$message.warning('请输入密码')
            }

            let apiName = 'login'
            switch (this.loginType) {
                case LOGIN_TYPE.ADMIN:        apiName = 'login'; break;
                case LOGIN_TYPE.ADMIN_MEMBER: apiName = 'login'; break;
                case LOGIN_TYPE.OPERATOR:     apiName = 'operatorLogin';      break;
                case LOGIN_TYPE.OPERATOR_MEMBER:  apiName = 'operatorLogin';  break;
                case LOGIN_TYPE.CLEARING_ACCOUNT: apiName = 'settlementLogin';break;
            }

            try {
                const res = await Core.Api.User[apiName](form)
                console.log('handleLogin res', res)
                let operator_custom = {}
                Core.Data.setToken(res.token);
                Core.Data.setLoginType(this.loginType);

                let clearing_account = ''

                switch (this.loginType) {
                    case LOGIN_TYPE.ADMIN:
                    case LOGIN_TYPE.ADMIN_MEMBER:
                        Core.Data.setUser(res.user);
                        Core.Data.setUserType('ADMIN');
                        operator_custom = {}
                        break;
                    case LOGIN_TYPE.OPERATOR:
                        let user = res.user || {};
                        if (!user.uid) {
                            // 历史遗留问题 有部分运营商 没有user.uid
                            try {
                                const _user = await Core.Api.Operator.uidCheck();
                                user = _user
                                console.log('handleLogin uidCheck user:', _user)
                            } catch (err) {
                                console.log('handleLogin uidCheck err:', err)
                            }
                        }
                        Core.Data.setUser(user);
                        Core.Data.setUserType('OPERATOR')
                        this.user = user
                        operator_custom = user.operator_custom || {}
                        break;
                    case LOGIN_TYPE.CLEARING_ACCOUNT:
                        clearing_account = res.clearing_account.id
                        Core.Data.setUser(res.clearing_account);
                        Core.Data.setUserType('CLEARING_ACCOUNT')
                        operator_custom = res.operator.operator_custom || {}
                        break;
                }
                Core.Data.setOperatorCustom(operator_custom); // 运营商定制

                Core.Data.setAuthority('')
                this.getAuthority( clearing_account );
            } catch (err) {
                console.log('handleLogin err', err)
            }
        },
        async getAuthority(clearing_account_id) {
            if (this.loginType === LOGIN_TYPE.CLEARING_ACCOUNT) {
                Core.Data.setAuthority({ CLEARING_ACCOUNT: true })
                this.$router.replace({
                    path: '/settlement-clearing-account-detail',
                    query: {
                        id: clearing_account_id,
                    }
                });
                return
            }
            try {
                const res = await Core.Api.Authority.listByUser()
                Core.Util.getAuthority(res, this.user);

                Core.Data.setServiceChargeTipFlag(0);
                Core.Data.setInsuranceTipTime(0)

                this.$router.replace({ path: '/home' })
            } catch (err) {
                console.log('getAuthority err:', err)
            }
        },

        async handleLoginByToken(token) {
            this.loginType = LOGIN_TYPE.OPERATOR;
            Core.Data.setToken(token);
            Core.Data.setLoginType(LOGIN_TYPE.OPERATOR);
            Core.Data.setUserType('OPERATOR');
            Core.Data.setAuthority('')
            try {
                const res = await Core.Api.Operator.detail()
                let operator = res.operator || {}
                console.log('handleLoginByToken operator:', operator)
                Core.Data.setUser(operator);
                Core.Data.setOperatorCustom(operator.operator_custom || {}); // 运营商定制信息
                this.user = res.operator
                this.getAuthority()
            } catch (err) {
                console.log('handleLoginByToken err:', err)
            }
        },
    }
};
</script>

<style lang="scss">
#Login {
    // @include flex(column, flex-start, center);
    height: 100vh;
    .login-head {
        @include no-select;
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        padding: 0 40px;
        background: $bg_login_head;
        @include flex(row, space-between, center);
        .left {
            @include flex(row, flex-start, center);
            .platform-name {
                font-size: 24px;
                color: $white;
                font-weight: 700;
            }
            .platform-img {
                height: 21px;
            }
            .text {
                font-size: 16px;
                color: $white;
            }
            .line {
                width: 1px;
                height: 17px;
                background: $black;
                opacity: 0.2;
                margin: 0 14px;
            }
        }
        .right {
            display: flex;
            position: relative;
            .change-item {
                cursor: pointer;
                min-width: 148px;
                height: 32px;
                padding: 0 12px;
                line-height: 32px;
                border-radius: 16px;
                font-weight: 500;
                text-align: center;
                background: rgba($black, 0.15);
                border: 1px solid rgba($white, 0.8);
                color: rgba($white, 0.8);
                @include flex(row, center, center);
                font-size: 14px;
                .icon {
                    font-size: 12px;
                    margin-right: 6px;
                }
            }
        }
    }
    .login-container {
        width: 100%;
        height: calc(100% - 60px);
        @include flex(column, center, center);
        .login-form {
            background: $white;
            padding: 50px 35px;
            width: 350px;
            position: relative;
            border-radius: 6px;
            border: 1px solid $bc_container;
            .logo {
                position: absolute;
                top: -40px;
                left: 135px;
                img {
                    background: $white;
                    width: 80px;
                    height: 80px;
                    padding: 5px;
                    border-radius: 50%;
                }
            }
            .login-type {
                width: 100%;
                text-align: center;
                font-size: 20px;
                font-weight: 500;
                color: $tc_import;
                margin-bottom: 40px;
            }
            .icon {
                color: rgba($black,0.25);
            }

            .login-form-item, .login-form-button {
                width: 100%;
                height: 44px;
                margin-bottom: 24px;
            }

            .find-back-form-item, .find-back-form-button {
                width: 100%;
                height: 36px;
                margin-bottom: 18px;
            }

            .login-form-button, .find-back-form-button {
                background-color: $link;
            }

            .find-back-tip {
                position: absolute;
                right: 35px;
                bottom: 45px
            }
        }
        .find-back-form {
            padding: 50px 35px 40px;
            .login-type {
                margin-bottom: 20px;
            }
            .find-back-tip {
                bottom: 30px
            }
        }
        .find-back-form-tip {
            position: relative;
            font-size: 12px;
            top: -14px;
            color: $tc_disabled;
        }
    }
    /* .foot {
        font-size: 14px;
        color: $tc_info;
        margin-bottom: 60px;
    } */
}
</style>
<style lang="scss">
.login-container {
    .login-form-item {
        .ant-input-prefix {
            font-size: 16px;
        }
        .ant-input {
            padding-left: 44px;
            height: 44px;
            font-size: 14px;
        }
    }
    .find-back-form-item {
        .ant-input-prefix {
            font-size: 14px;
        }
        .ant-input {
            padding-left: 44px;
            height: 36px;
            font-size: 12px;
        }
    }
    .anticon-check-circle {
        color: $success;
    }
    .anticon-close-circle {
        color: $error;
    }
}
.login-type-change-dropdown {
    .ant-dropdown-menu-item {
        height: 40px;
        display: flex;
        align-items: center;
        padding: 10px !important;
        img {
            margin-right: 5px;
            width: 28px;
            height: 28px;
        }
        &:hover {
            color: $link;
            font-weight: 500;
        }
    }

}
</style>